import {getAccessAdministrationRole} from "@project/sdk/access-administration";
import {GetAccessAdministrationRoleResponse} from "@project/sdk/access-administration/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../shared/query/query-policies";
import {roleKeys} from "../../access-administration-keys";

export function getRoleQueryOptions(roleId: string) {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: roleKeys.detail(roleId),
    queryFn: async ({signal}) =>
      GetAccessAdministrationRoleResponse.parse(
        await getAccessAdministrationRole(roleId, {signal}),
      ),
  });
}
